const googlePhotoUrlRegex = /=?\/?s96-c/g

const fixPhotoUrlSize = (string) => {
  if (string.includes('facebook')) return (string += '?height=512&width=512')
  return string.replace(googlePhotoUrlRegex, '')
}

export default fixPhotoUrlSize
